import type { FeatureDefinitionGroup } from '../feature-definition-types';

export type FormsRelativePath =
  | '/submissions'
  | '/library'
  | '/kiosk'
  | '/templates'
  | '/builder/new'
  | '/digitization';

export const featureDefinition = {
  root: '/forms',
  iconName: 'forms',
  items: {
    '/submissions': {
      label: 'Submissions',
      trackingId: 'forms-submissions',
      description:
        'Displays user-submitted form data. Ideal for reviewing patient intake, consent forms, or survey responses.',
    },
    '/library': {
      label: 'My Forms',
      trackingId: 'forms-my-forms',
      description:
        'Collection of all created forms in your account. Manage, duplicate, or edit your practice’s custom digital forms.',
    },
    '/kiosk': {
      label: 'Kiosk Mode',
      trackingId: 'forms-kiosk-mode',
      description: 'A simplified, patient-facing mode for in-office form completion on a tablet or kiosk.',
    },
    '/templates': {
      label: 'Templates',
      trackingId: 'forms-templates',
      description: 'Library of form templates. Browse, select, and adapt pre-built templates for quick deployment.',
    },
    '/builder/new': {
      label: 'Builder',
      trackingId: 'forms-builder',
      description: 'Create or customize digital forms from scratch using a drag-and-drop interface.',
    },
    '/digitization': {
      label: 'Request Digitization',
      trackingId: 'forms-request-digitization',
      description: 'Request professional conversion of paper or PDF forms into interactive digital versions.',
    },
  },
} as const satisfies FeatureDefinitionGroup<'/forms', 'forms', FormsRelativePath>;
